import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../../lib/api-client';
import { useMe } from '../../../lib/useMe';

export function ImpersonationBanner() {
  const { data: me } = useMe();
  const queryClient = useQueryClient();

  const stopMutation = useMutation({
    mutationFn: () => api.post('/v1/settings/access-levels/impersonation/stop'),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['me'] });
      // The effective identity changed, so every per-employee cache (profile, manager card,
      // viewer-grants) may answer for the wrong viewer; drop them all.
      void queryClient.invalidateQueries({ queryKey: ['employee'] });
    },
  });

  if (!me?.impersonating) {
    return null;
  }

  return (
    <div className="flex items-center justify-between bg-amber-400 px-6 py-2 text-sm font-medium text-amber-950">
      <span>
        Viewing as <strong>{me.effectiveDisplayName}</strong>
      </span>
      <button
        type="button"
        onClick={() => stopMutation.mutate()}
        disabled={stopMutation.isPending}
        className="ml-4 rounded border border-amber-700 bg-amber-500 px-3 py-1 text-xs font-semibold text-amber-950 hover:bg-amber-600 disabled:opacity-60"
      >
        {stopMutation.isPending ? 'Stopping…' : 'Stop viewing as'}
      </button>
    </div>
  );
}
